import cn from 'classnames';
import { Button } from 'primereact/button';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './Form.module.scss';

interface FormFooterProps {
  isPending: boolean;
  dataTestId: string;
  cancelCallback?: () => void;
  submitButtonText?: string;
}

export function FormFooter({ isPending, dataTestId, cancelCallback, submitButtonText }: FormFooterProps) {
  const { t } = useTranslation([i18nNameSpace.USERS]);
  const { formState } = useFormContext();

  const submitButtonTextTranslationKey = submitButtonText ? t(submitButtonText) : t('page.adminPanel.common.proceed');

  const shouldDisableSubmit = !formState.isDirty || isPending;

  return (
    <div className='row'>
      <div className='col-12'>
        <div className={styles.footer}>
          {Boolean(cancelCallback) && (
            <Button
              label={t('page.adminPanel.common.cancel')}
              onClick={cancelCallback}
              type='button'
              className={cn('p-button-text', styles.cancelButton)}
              data-testid='cancel-button'
            />
          )}
          <Button data-testid={dataTestId} type='submit' disabled={shouldDisableSubmit} loading={isPending}>
            {submitButtonTextTranslationKey}
          </Button>
        </div>
      </div>
    </div>
  );
}
